module.exports = __webpack_public_path__ + "img/1.0e385100.png";